import StatsByPackageCancellations from './StatsByPackageCancellations';

export default StatsByPackageCancellations;
